import api from "./axios";


// ============================================================
// RULES
// ============================================================

export const getTaDaRules = async () => {

    const response = await api.get(
        "/ta-da/rules"
    );

    return response.data;
};


export const createTaDaRule = async (
    data
) => {

    const response = await api.post(
        "/ta-da/rules",
        data
    );

    return response.data;
};


export const updateTaDaRule = async (
    id,
    data
) => {

    const response = await api.patch(
        `/ta-da/rules/${id}`,
        data
    );

    return response.data;
};


// ============================================================
// CLAIMS
// ============================================================

export const getTaDaClaims = async (
    page = 1,
    limit = 10,
    filters = {}
) => {

    const response = await api.get(
        "/ta-da/claims",
        {
            params: {
                page,
                limit,
                ...filters,
            },
        }
    );

    return response.data;
};


export const getTaDaClaim = async (
    id
) => {

    const response = await api.get(
        `/ta-da/claims/${id}`
    );

    return response.data;
};


export const createTaDaClaim = async (
    data
) => {

    const response = await api.post(
        "/ta-da/claims",
        data
    );

    return response.data;
};


export const updateTaDaClaim = async (
    id,
    data
) => {

    const response = await api.patch(
        `/ta-da/claims/${id}`,
        data
    );

    return response.data;
};


export const submitTaDaClaim = async (
    id
) => {

    const response = await api.post(
        `/ta-da/claims/${id}/submit`
    );

    return response.data;
};


export const approveTaDaClaim = async (
    id,
    data
) => {

    const response = await api.post(
        `/ta-da/claims/${id}/approve`,
        data
    );

    return response.data;
};


export const rejectTaDaClaim = async (
    id,
    reason
) => {

    const response = await api.post(
        `/ta-da/claims/${id}/reject`,
        {
            reason,
        }
    );

    return response.data;
};


export const markTaDaClaimPaid = async (
    id,
    data = {}
) => {

    const response = await api.post(
        `/ta-da/claims/${id}/mark-paid`,
        data
    );

    return response.data;
};


export const cancelTaDaClaim = async (
    id
) => {

    const response = await api.delete(
        `/ta-da/claims/${id}`
    );

    return response.data;
};


// ============================================================
// PROOF FILE
// ============================================================

export const uploadTaDaProof = async (file) => {
    const formData = new FormData();

    formData.append(
        "file",
        file
    );

    formData.append(
        "folder",
        "tada"
    );

    const response = await api.post(
        "/uploads",
        formData,
        {
            headers: {
                "Content-Type": undefined,
            },
        }
    );

    return response.data;
};